import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export const MarketingLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};
